import React from "react";
import { Row, Col, Form } from "react-bootstrap";

const RetencionesSection = ({
  formData,
  errors,
  handleChange,
  handleBlur,
  handleFocus,
  isReadOnly
}) => {
  const providerInfo = formData.providerInfo || {};

  return (
    <div className="form-section p-2 p-sm-3 mb-4 border rounded bg-white">
      <h5 className="bg-light p-2 mb-3 border-bottom">
        3.- INFORMACIÓN PARA ENVÍO DE RETENCIÓN ELECTRÓNICA
      </h5>

      <Row className="g-2 g-sm-3">
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">EMAIL PARA RETENCIONES:</Form.Label>
            <Form.Control
              type="email"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.email_retencion}
              value={providerInfo.email_retencion || ""}
              onChange={handleChange("email_retencion")}
              onBlur={handleBlur("email_retencion")}
              onFocus={handleFocus("email_retencion")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">
              {errors.email_retencion}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default RetencionesSection;